export const formMixin = {
  data() {
    return {
      formBlocked: false
    };
  },
  methods: {
    blockUI() {
      this.formBlocked = true;
    },
    unblockUI() {
      this.formBlocked = false;
    }
  }
};